import FieldSwitch from './FieldSwitch';

export default FieldSwitch;



// WEBPACK FOOTER //
// ./src/components/atoms/FieldSwitch/index.js